<template>
    <flex-element :element-type="elementType" tag="li">
        <a-link v-bind="element(1)" @element-updated="elementUpdated" />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    mixins: [baseOrganism],

    props: {
        index: {
            type: Number,
            required: true,
        },
    },
};
</script>
